/**
 * Pedidos GET a ficheiros em /public através do ngrok podem devolver a página HTML de aviso
 * em vez do binário, porque <img>/<audio>/<video> não enviam o cabeçalho de bypass.
 * Ver: https://ngrok.com/docs/guides/device-gateway/browser-warning
 */

export function isLikelyNgrokPublicUrl(url) {
  if (!url || typeof url !== "string") return false;
  const u = url.toLowerCase();
  return (
    u.includes("ngrok-free.app") ||
    u.includes("ngrok.app") ||
    u.includes("ngrok.io") ||
    u.includes("ngrok.dev")
  );
}

/**
 * Obtém o ficheiro com cabeçalho que evita a página de aviso do ngrok e devolve uma blob: URL.
 * Quem chama deve revogar com URL.revokeObjectURL quando não precisar.
 */
export async function fetchPublicMediaBlobUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") {
    throw new Error("URL inválida");
  }
  const res = await fetch(rawUrl, {
    method: "GET",
    mode: "cors",
    credentials: "omit",
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const blob = await res.blob();
  if (!blob || blob.size === 0) {
    throw new Error("Blob vazio");
  }
  return URL.createObjectURL(blob);
}
